import { render, staticRenderFns } from "./ContractOverviewDashboardView.vue?vue&type=template&id=3c4b6dd4&scoped=true&"
import script from "./ContractOverviewDashboardView.vue?vue&type=script&lang=js&"
export * from "./ContractOverviewDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./ContractOverviewDashboardView.vue?vue&type=style&index=0&id=3c4b6dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4b6dd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VRow})
